(() => {
  const initialize = (root) => {
    if (!root || root.dataset.pmPackReady === 'true') return;

    const dataNode = root.querySelector('[data-pm-product-data]');
    if (!dataNode) return;

    let products;
    try {
      products = JSON.parse(dataNode.textContent);
    } catch (error) {
      console.error('Pulse Pack PDP: no se pudo leer la información de productos.', error);
      return;
    }

    root.dataset.pmPackReady = 'true';

    const stage = root.querySelector('[data-pm-stage]');
    const thumbs = root.querySelector('[data-pm-thumbs]');
    const format = root.querySelector('[data-pm-format]');
    const chip = root.querySelector('[data-pm-chip]');
    const title = root.querySelector('[data-pm-title]');
    const lead = root.querySelector('[data-pm-lead]');
    const price = root.querySelector('[data-pm-price]');
    const compare = root.querySelector('[data-pm-compare]');
    const daily = root.querySelector('[data-pm-daily]');
    const benefits = root.querySelector('[data-pm-benefits]');
    const atc = root.querySelector('[data-pm-atc]');
    const stickyAtc = root.querySelector('[data-pm-sticky-atc]');
    const stickyName = root.querySelector('[data-pm-sticky-name]');
    const stickyDetail = root.querySelector('[data-pm-sticky-detail]');
    const stickyPrice = root.querySelector('[data-pm-sticky-price]');
    const stickyImage = root.querySelector('.pm-pack__sticky-product img');

    const activateThumb = (thumb) => {
      root.querySelectorAll('[data-pm-thumb]').forEach((item) => {
        const active = item === thumb;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const stageImage = stage?.querySelector('[data-pm-stage-image], img');
      if (stageImage) {
        stageImage.removeAttribute('srcset');
        stageImage.removeAttribute('sizes');
        stageImage.src = thumb.dataset.src;
        stageImage.alt = thumb.dataset.alt || '';
      }
    };

    const bindThumbs = () => {
      root.querySelectorAll('[data-pm-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => activateThumb(thumb));
      });
    };

    const renderGallery = (product) => {
      if (!stage || !thumbs || !product.media?.length) return;

      thumbs.replaceChildren();
      product.media.forEach((media, index) => {
        const button = document.createElement('button');
        const image = document.createElement('img');
        button.className = `pm-pack__thumb${index === 0 ? ' is-active' : ''}`;
        button.type = 'button';
        button.dataset.pmThumb = '';
        button.dataset.src = media.src;
        button.dataset.alt = media.alt || product.name;
        button.setAttribute('aria-label', `Ver imagen ${index + 1} de ${product.name}`);
        button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
        button.setAttribute('role', 'listitem');
        image.src = media.thumb;
        image.alt = media.alt || product.name;
        image.loading = 'lazy';
        button.append(image);
        thumbs.append(button);
      });

      stage.replaceChildren();
      const badge = document.createElement('span');
      const image = document.createElement('img');
      badge.className = 'pm-pack__stage-badge';
      badge.dataset.pmBadge = '';
      badge.textContent = product.badge;
      image.dataset.pmStageImage = '';
      image.src = product.media[0].src;
      image.alt = product.media[0].alt || product.name;
      image.decoding = 'async';
      stage.append(badge, image);
      bindThumbs();
    };

    const renderBenefitCopy = (copy, item) => {
        const heading = document.createElement('strong');
        const separator = item.indexOf(':');
        const title = separator >= 0 ? item.slice(0, separator).trim() : item.trim();
        const description = separator >= 0 ? item.slice(separator + 1).trim() : '';
        heading.textContent = title;
        copy.replaceChildren();
        copy.append(heading);
        if (description) {
          const detail = document.createElement('span');
          detail.textContent = description;
          copy.append(detail);
        }
    };

    const renderBenefits = (items) => {
      if (!benefits) return;
      benefits.replaceChildren();
      items.filter(Boolean).forEach((item) => {
        const row = document.createElement('li');
        const check = document.createElement('span');
        const copy = document.createElement('p');
        check.setAttribute('aria-hidden', 'true');
        check.textContent = '✓';
        renderBenefitCopy(copy, item);
        row.append(check, copy);
        benefits.append(row);
      });
    };

    benefits?.querySelectorAll('p').forEach((copy) => {
      if (!copy.querySelector('strong')) renderBenefitCopy(copy, copy.textContent);
    });

    const renderProduct = (key) => {
      const product = products[key];
      if (!product) return;

      format.textContent = product.format;
      chip.textContent = product.chip || '';
      chip.hidden = !product.chip;
      title.textContent = product.title;
      lead.innerHTML = product.leadHtml;
      price.textContent = product.price;
      compare.textContent = product.compare || '';
      compare.hidden = !product.compare;
      daily.textContent = product.daily;
      renderBenefits(product.benefits || []);
      renderGallery(product);

      root.querySelectorAll('[data-pm-product-key]').forEach((button) => {
        const active = button.dataset.pmProductKey === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      root.querySelectorAll('[data-pm-variant-input]').forEach((input) => {
        input.value = product.variantId;
      });

      const available = Boolean(product.available);
      atc.disabled = !available;
      atc.textContent = available ? `Agregar ${product.shortName} al carrito` : 'Agotado';
      stickyAtc.disabled = !available;
      stickyAtc.textContent = available ? `Agregar ${product.shortName}` : 'Agotado';
      stickyName.textContent = product.name;
      stickyDetail.textContent = product.detail;
      stickyPrice.textContent = product.price;
      if (stickyImage && product.media?.[0]) {
        stickyImage.src = product.media[0].thumb;
        stickyImage.alt = product.name;
      }

      root.dataset.activeProduct = key;
    };

    bindThumbs();

    root.querySelectorAll('[data-pm-product-key]').forEach((button) => {
      button.addEventListener('click', () => renderProduct(button.dataset.pmProductKey));
    });

    root.querySelectorAll('[data-pm-quantity]').forEach((quantity) => {
      const input = quantity.querySelector('input');
      quantity.querySelectorAll('[data-pm-qty]').forEach((button) => {
        button.addEventListener('click', () => {
          const current = Math.max(1, Number.parseInt(input.value, 10) || 1);
          input.value = button.dataset.pmQty === 'plus' ? current + 1 : Math.max(1, current - 1);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    const storySlider = root.querySelector('[data-pm-story-slider]');
    const storyControls = root.querySelector('[data-pm-story-controls]');
    if (storySlider && storyControls) {
      const storySlides = Array.from(storySlider.querySelectorAll('[data-pm-story-slide]'));
      const storyPrevious = storyControls.querySelector('[data-pm-story-prev]');
      const storyNext = storyControls.querySelector('[data-pm-story-next]');
      const storyCurrent = storyControls.querySelector('[data-pm-story-current]');
      const mobileStories = window.matchMedia('(max-width: 820px)');
      let activeStory = 0;
      let storyFrame;

      const updateStoryState = (index) => {
        activeStory = Math.max(0, Math.min(index, storySlides.length - 1));
        storyCurrent.textContent = String(activeStory + 1);
        storyPrevious.disabled = activeStory === 0;
        storyNext.disabled = activeStory === storySlides.length - 1;
        storySlides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-current', slideIndex === activeStory ? 'true' : 'false');
        });
      };

      const goToStory = (index) => {
        if (!mobileStories.matches) return;
        const targetIndex = Math.max(0, Math.min(index, storySlides.length - 1));
        storySlider.scrollTo({ left: storySlides[targetIndex].offsetLeft, behavior: 'smooth' });
        updateStoryState(targetIndex);
      };

      const syncStoryFromScroll = () => {
        if (!mobileStories.matches) return;
        window.cancelAnimationFrame(storyFrame);
        storyFrame = window.requestAnimationFrame(() => {
          const nearestIndex = storySlides.reduce((nearest, slide, index) => {
            const currentDistance = Math.abs(slide.offsetLeft - storySlider.scrollLeft);
            const nearestDistance = Math.abs(storySlides[nearest].offsetLeft - storySlider.scrollLeft);
            return currentDistance < nearestDistance ? index : nearest;
          }, 0);
          updateStoryState(nearestIndex);
        });
      };

      storyPrevious.addEventListener('click', () => goToStory(activeStory - 1));
      storyNext.addEventListener('click', () => goToStory(activeStory + 1));
      storySlider.addEventListener('scroll', syncStoryFromScroll, { passive: true });
      storySlider.addEventListener('keydown', (event) => {
        if (!mobileStories.matches) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goToStory(activeStory - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goToStory(activeStory + 1);
        }
      });
      mobileStories.addEventListener('change', () => {
        if (mobileStories.matches) goToStory(0);
      });
      updateStoryState(0);
    }

    const benefitRows = Array.from(root.querySelectorAll('[data-pm-benefit-row]'));
    benefitRows.forEach((row) => {
      row.addEventListener('toggle', () => {
        if (!row.open) return;
        benefitRows.forEach((otherRow) => {
          if (otherRow !== row) otherRow.open = false;
        });
      });
    });

    const purchase = root.querySelector('[data-pm-product-form]');
    const sticky = root.querySelector('[data-pm-sticky]');
    if (purchase && sticky) {
      const updateSticky = () => {
        const show = purchase.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        root.classList.toggle('has-sticky', show);
      };
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      updateSticky();
    }
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-pm-pack]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
